

export default {

    getList(pm) {
        if(pm && pm.type && pm.gateway_name) {
          if(pm.gateway_name === 'EBANX' && pm.type === 'card' ) { // convert to switch if more cases is required
                      return this.ebanx_document_list;
        }
     
        return [];
    }

   
},

ebanx_document_list: [
    {
        display_name: "CDI",
        value: "cdi",
    },
    {
        display_name: "CUIL",
        value: "cuil",
    },
    {
    display_name: "CUIT",
        value: "cuit",
    },
    {
        display_name: "DNI",
        value: "dni",
    },
    {
        display_name: "CPF",
        value: "cpf",
    },
    {
        display_name: "CNPJ",
        value: "cnpj",
    },
    {
        display_name: "RUT",
        value: "rut",
    },
    {
        display_name: "CC",
        value: "cc",
    },
    {
        display_name: "CE",
        value: "ce",
    },
    {
        display_name: "NIT",
        value: "nit",
    },
    {
        display_name: "DOC",
        value: "doc",
    },
    {
        display_name: "CI",
        value: "ci",
    },
    
],
}